export default __webpack_public_path__ + "static/media/model-journey-map.feba450a.jpg";